import React, { useEffect } from "react";
import BottomStickyActions from "../components/BottomStickyActions.js";
import { toast } from "react-toastify";
import { editCardApi } from "../services/leitnerApi.js";
import { checkErrorMessage, checkResponseData } from "../utils/utilsFunctions.js";

export default function EditCard({ handleEditCardInfo, editCardInfo, handleEditCardDone }) {
  const [frontCard, setFrontCard] = React.useState("");
  const [backCard, setBackCard] = React.useState("");
  const [waiting, setWaiting] = React.useState(false);

  const submitEditCard = async () => {
    setWaiting(true);
    try {
      const response = await editCardApi({
        cardId: editCardInfo["card"]["_id"],
        frontCard,
        backCard: [backCard],
      });
      const resData = checkResponseData(response);
      if (resData["success"]) {
        handleEditCardDone(editCardInfo["card"], { frontCard, backCard: [backCard] });
        toast.success(resData["message"] || "ویرایش با موفقیت انجام شد");
        handleEditCardInfo({ status: false });
      } else {
        toast.error("مشکلی در ذخیره ویرایش وجود دارد");
      }
      setWaiting(false);
    } catch (error) {
      const errData = checkErrorMessage(error);
      let errMsg = errData["titles"] || errData["message"];
      toast.error(errMsg || "مشکلی در ذخیره ویرایش وجود دارد");
      setWaiting(false);
    }
  };

  useEffect(() => {
    setFrontCard(editCardInfo["card"]["frontCard"]);
    setBackCard(editCardInfo["card"]["backCard"].join(" , "));
  }, []);

  return (
    <div className="container" style={{ paddingBottom: 120 }}>
      <div className="card">
        <div style={{ textAlign: "center", padding: "20px 0" }}>
          <label className="label">جلو کارت</label>
          <textarea
            className="textarea"
            value={frontCard}
            onChange={(e) => setFrontCard(e.target.value)}
            style={{ fontSize: 20, fontWeight: 700, textAlign: "center" }}
          />
          <label className="label" style={{ marginTop: 16 }}>
            پشت کارت
          </label>
          <textarea
            className="textarea"
            value={backCard}
            onChange={(e) => setBackCard(e.target.value)}
            style={{ fontSize: 16, textAlign: "center" }}
          />
        </div>
      </div>
      <BottomStickyActions>
        {waiting ? (
          <div className="center" style={{ flex: 1, gap: 8 }}>
            <div className="spinner small"></div>
            <span>در حال ذخیره</span>
          </div>
        ) : (
          <>
            <button className="btn ghost" style={{ flex: 1 }} onClick={() => handleEditCardInfo({ status: false })}>
              انصراف
            </button>
            <button className="btn success" style={{ flex: 1 }} onClick={submitEditCard}>
              ذخیره
            </button>
          </>
        )}
      </BottomStickyActions>
    </div>
  );
}
